
import React, { useState, useEffect } from 'react';
import Button from '../base/Button';

const Navigation: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/95 backdrop-blur-sm shadow-lg' : 'bg-black'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <h1 className="text-white text-xl font-bold font-serif">
              Glory Odudu
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <button
                onClick={() => scrollToSection('home')}
                className="text-white hover:text-yellow-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-white hover:text-yellow-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-white hover:text-yellow-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('speaking')}
                className="text-white hover:text-yellow-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer"
              >
                Speaking
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-white hover:text-yellow-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer"
              >
                Contact
              </button>
            </div>
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button variant="primary" size="sm">
              Book Strategy Call
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-white hover:text-yellow-600 p-2 cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-black/95">
              <button
                onClick={() => scrollToSection('home')}
                className="text-white hover:text-yellow-600 block px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-white hover:text-yellow-600 block px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-white hover:text-yellow-600 block px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('speaking')}
                className="text-white hover:text-yellow-600 block px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Speaking
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-white hover:text-yellow-600 block px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Contact
              </button>
              <div className="px-3 py-2">
                <Button variant="primary" size="sm">
                  Book Strategy Call
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
